export class TrafficDeviationsConfig {
    showFormValuesAsJson = false;
    showPrintNotValidatedListButton = false;

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}